import Links from '@component/navigation/links';

import Icon from '@component/icon';
import LinkHelper from '@component/navigation/helpers/link';
import { userHasPlusTier, userHasFreeTier } from '@app/helper/user';

import LaunchDarkly from '@app/modules/launchdarkly/index';
import { FF_IMPLEMENT_SPACES } from '@app/constant/experiments';

const accountUser = (navigation, user) => {
  navigation = LinkHelper.attachAccountMenu(navigation, user);
  navigation = LinkHelper.attachSignoutLink(navigation);

  if (userHasPlusTier(user)) {
    navigation = LinkHelper.removePlusPageLink(navigation, 'hamburger');

    // 2nd Plus Feature item
    if (LaunchDarkly.getVariant(FF_IMPLEMENT_SPACES)) {
      navigation.hamburger.items.push(
        LinkHelper.attachFeatureSpacesLink(navigation).projects
      );
    }
  }

  navigation = LinkHelper.replaceProfileName(navigation, '');

  if (userHasFreeTier(user)) {
    navigation = LinkHelper.attachUpgradeLink(navigation, 'mobile');
  }

  return navigation;
};

export default {
  create: (user) => {
    let navigation = {
      hamburger: {
        id: 'hamburger',
        component: Icon,
        options: { type: 'Hamburger' },
        items: [
          Links.homeItem,
          Links.uploadItem,
          Links.helpItem,
          Links.aboutItem,
          Links.plusItem,
          Links.productsItem,
          Links.advertiseItem,
        ],
      },
      logo: {
        id: 'logo',
        component: Icon,
        options: { type: 'Logo', shadow: false, width: 44 },
        path: '/',
      },
      account: Links.loginItem,
    };

    navigation = user.loggedIn ? accountUser(navigation, user) : navigation;

    return Object.values(navigation);
  },
};
